import { Alpine, Livewire } from "@shared/livewire.js";

Alpine.data("loadDonationCheckoutData", (props) => ({
    props: props,
    componentId: null,
    frequency: null,
    amount: null,
    radioAmount: null,
    currency: null,
    defaultTierAmount: null,
    customAmountString: null,
    isAnyTierDescriptionSet: null,
    tiers: null,
    doNotSendGift: null,
    tributeFieldsEnabled: null,
    tributeType: null,
    commentEnabled: null,
    customField0Enabled: null,
    customField1Enabled: null,
    customField2Enabled: null,
    customField3Enabled: null,
    customField4Enabled: null,
    customField5Enabled: null,
    anonymousGift: null,
    step2Loading: null,
    recaptchaKey: null,

    init() {
        this.componentId = document
            .querySelector("[wire\\:id]")
            .getAttribute("wire:id");
        this.frequency = this.props.frequency;
        this.amount = this.props.amount;
        this.radioAmount = this.props.radioAmount;
        this.currency = this.props.currency;
        this.defaultTierAmount = this.props.defaultTierAmount;
        this.customAmountString = this.props.customAmountString;
        this.isAnyTierDescriptionSet = this.props.isAnyTierDescriptionSet;
        this.tiers = JSON.parse(this.props.tiers);
        this.doNotSendGift = this.props.doNotSendGift;
        this.tributeFieldsEnabled = this.props.tributeFieldsEnabled;
        this.tributeType = this.props.tributeType;
        this.commentEnabled = this.props.commentEnabled;
        this.customField0Enabled = this.props.customField0Enabled;
        this.customField1Enabled = this.props.customField1Enabled;
        this.customField2Enabled = this.props.customField2Enabled;
        this.customField3Enabled = this.props.customField3Enabled;
        this.customField4Enabled = this.props.customField4Enabled;
        this.customField5Enabled = this.props.customField5Enabled;
        this.anonymousGift = this.props.anonymousGift;
        this.step2Loading = this.props.step2Loading;
        this.recaptchaKey = this.props.recaptchaKey;
        this.environment = this.props.environment;
        this.showCustomAmountDescription =
            this.props.showCustomAmountDescription;

        // Livewire.find(this.componentId).set('frequency', this.frequency)
        // Livewire.find(this.componentId).set('amount', this.amount)
        // Livewire.find(this.componentId).set('currency', this.currency)

        Livewire.find(this.componentId).on("step1-completed", () => {
            this.scrollToTop();
        });

        Livewire.find(this.componentId).on("step2-completed", (data) => {
            this.step2Loading = false;
            if (data.success) {
                this.scrollToTop();
            }
        });
    },

    scrollToTop() {
        const wofDonationForm = document.querySelector("[wire\\:id]");
        if (wofDonationForm) {
            if (wofDonationForm.getBoundingClientRect().top < 0) {
                window.scroll({
                    top:
                        wofDonationForm.getBoundingClientRect().top +
                        window.scrollY,
                    behavior: "smooth",
                });
            }
        }
    },

    setAmountToTier(val) {
        this.amount = val;
        Livewire.find(this.componentId).set("amount", val);
        this.radioAmount = val;
        this.customAmountString = "";
    },

    mapCurrencyToSymbol(currency) {
        switch (currency) {
            case "eur":
                return "€";
            case "gbp":
                return "£";
            case "cad":
                return "C$";
            case "aud":
                return "A$";
            default:
                return "$";
        }
    },

    onCustomAmountChange(val) {
        if (
            this.customAmountString.split(".").length > 1 &&
            this.customAmountString.split(".")[1].length > 2
        ) {
            this.customAmountString = parseFloat(
                this.customAmountString
            ).toFixed(2);
        }

        if (this.customAmountString.length > 0) {
            this.amount = parseFloat(this.customAmountString);
            Livewire.find(this.componentId).set("amount", this.amount);
        } else {
            this.amount = 0;
            Livewire.find(this.componentId).set("amount", 0);
            this.radioAmount = 0;
        }
    },

    onCustomAmountFocus() {
        this.radioAmount = 0;
        if (this.customAmountString.length === 0) {
            this.amount = 0;
            Livewire.find(this.componentId).set("amount", 0);
        }
    },

    onCustomAmountBlur() {
        if (
            this.customAmountString.split(".").length > 1 &&
            this.customAmountString.split(".")[1].length === 1
        ) {
            this.customAmountString = this.customAmountString + "0";
        }
    },

    mapFrequencyToLabel(frequency) {
        if (frequency === "one_time") {
            return "one time";
        }
        return frequency;
    },

    getTierDescriptionForAmount() {
        if (
            this.tiers &&
            this.isAnyTierDescriptionSet &&
            this.radioAmount === 0
        ) {
            for (let i = this.tiers.length - 1; i >= 0; i--) {
                if (
                    this.amount >= this.tiers[i].fields.amount &&
                    this.tiers[i].fields.description
                ) {
                    return this.tiers[i].fields.description;
                }
            }
        }
        return "";
    },

    onTributeFieldsToggle(val) {
        if (!this.tributeFieldsEnabled) {
            this.tributeType = "tribute_type_honor";
            Livewire.find(this.componentId).set(
                "tributeType",
                "tribute_type_honor"
            );
        } else {
            this.tributeType = null;
            Livewire.find(this.componentId).set("tributeType", null);
        }
        this.tributeFieldsEnabled = val;
    },

    onSubmitStep2() {
        this.step2Loading = true;
        try {
            if (this.environment === "local") {
                Livewire.dispatch("recaptcha-executed", { token: "token" }); // Use when donation form is being used locally
                return;
            }
            grecaptcha
                .execute(this.recaptchaKey, { action: "submit" })
                .then((token) => {
                    Livewire.dispatch("recaptcha-executed", { token: token });
                });
        } catch (error) {
            this.step2Loading = false;
        }
    },

    closeValidationModal() {
        this.step2Loading = false;
        Livewire.dispatch("close-validation-modal");
    },
}));
